import { CampaignFeatureState, InitialState } from './campaign.state';
import { createReducer, on } from '@ngrx/store';
import { CampaignsActions, MediaPlatformActions } from './campaign-actions';
import { campaignsAdapter, platformsAdapter } from './campaign-adapters';


export const campaignReducer = createReducer(InitialState,
    on(CampaignsActions.getCampaignsSuccess, (state, { campaignsResponse }): CampaignFeatureState => {
      return {
        ...state,
        campaigns: campaignsAdapter.setAll(campaignsResponse, state.campaigns),
      };
    }),
    on(CampaignsActions.upsertCampaignSuccess, (state, { campaign }): CampaignFeatureState => {
      return {
        ...state,
        campaigns: campaignsAdapter.upsertOne(campaign, state.campaigns),
      };
    }),
    on(CampaignsActions.deleteCampaignSuccess, (state, { campaignId }): CampaignFeatureState => {
      return {
        ...state,
        campaigns: campaignsAdapter.removeOne(campaignId, state.campaigns),
      };
    }),
    on(CampaignsActions.archiveCampaignSuccess, (state, { campaign }): CampaignFeatureState => {
      return {
        ...state,
        campaigns: campaignsAdapter.upsertOne(campaign, state.campaigns),
      };
    }),
    // FILTERS
    on(CampaignsActions.updateTitleFilter, (state, { title }): CampaignFeatureState => {
      return {
        ...state,
        filters: { ...state.filters, title },
      };
    }),
    on(CampaignsActions.updateTypeFilter, (state, { campaignType }): CampaignFeatureState => {
      return {
        ...state,
        filters: { ...state.filters, type: campaignType },
      };
    }),
    on(CampaignsActions.updateStatusFilter, (state, { status }): CampaignFeatureState => {
      return {
        ...state,
        filters: { ...state.filters, status },
      };
    }),
    on(CampaignsActions.updateSortType, (state, { sortType }): CampaignFeatureState => {
      return {
        ...state,
        filters: { ...state.filters, sortType },
      };
    }),
    on(CampaignsActions.updateDateRange, (state, { from, to }): CampaignFeatureState => {
      return {
        ...state,
        filters: { ...state.filters, from, to },
      };
    }),
    on(CampaignsActions.updateGbpAccountIds, (state, { gbpAccountIds }): CampaignFeatureState => {
      return {
        ...state,
        filters: { ...state.filters, gbpAccountIds },
      };
    }),
    on(CampaignsActions.updateAllFilters, (state, { filters }): CampaignFeatureState => {
      return { ...state, filters };
    }),
    on(CampaignsActions.getClientTokensSuccess,
        CampaignsActions.setClientTokensSuccess, (state, { clientTokens }): CampaignFeatureState => {
      return { ...state, clientTokens };
    }),
    on(CampaignsActions.getValidationRulesSuccess, (state, { validationRules }): CampaignFeatureState => {
      return { ...state, validationRules };
    }),
    on(MediaPlatformActions.getPlatformsSuccess, (state, { platforms }): CampaignFeatureState => {
      return {
        ...state,
        platforms: platformsAdapter.setAll(platforms, state.platforms),
      };
    }),
    on(MediaPlatformActions.disconnectPlatformSuccess, (state, { platform }): CampaignFeatureState => {
      return {
        ...state,
        platforms: platformsAdapter.updateOne({
          id: platform.id,
          changes: platform,
        }, state.platforms),
      };
    }),
);
